import * as React from 'react'

import { Input } from '@/components/ui/input'
import { getCurrencySymbol } from '@/lib/currency'
import { cn } from '@/lib/utils'
import { useAuthStore } from '@/stores/auth-store'

type CurrencyInputProps = React.ComponentProps<typeof Input> & {
  currencySymbol?: string
}

function getInputPadding(symbol: string) {
  if (symbol.length >= 4) {
    return 'pl-14'
  }
  if (symbol.length >= 2) {
    return 'pl-10'
  }
  return 'pl-7'
}

export const CurrencyInput = React.forwardRef<HTMLInputElement, CurrencyInputProps>(
  ({ className, currencySymbol, type = 'number', step = '0.01', min = '0', ...props }, ref) => {
    const currentBranch = useAuthStore((state) => state.currentBranch)
    const symbol = currencySymbol
      ?? getCurrencySymbol(currentBranch?.currencySymbol, currentBranch?.currencyCode)

    return (
      <div className="relative">
        <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">
          {symbol}
        </span>
        <Input
          ref={ref}
          type={type}
          step={step}
          min={min}
          className={cn(getInputPadding(symbol), className)}
          {...props}
        />
      </div>
    )
  },
)

CurrencyInput.displayName = 'CurrencyInput'
